module.exports = __webpack_public_path__ + "public/SiteImages/large_no_image.jpeg?63dc6a2f";